/** Thrown by a records read when the run's year is outside the loaded records window; the step fails and offers a retry. */
export class AgentRecordsNotLoadedError extends Error {
    constructor(readonly year: number) {
        super(`Records of ${year} are not loaded`);
    }
}
